import { SItemWrapper } from './Tools.styles';

const ToolItem = ({ children }) => {
  return <SItemWrapper>{children}</SItemWrapper>;
};

export default ToolItem;
